import PoolsApi from '../api/pools'
import { addInfoNotification, addErrorNotification } from './notifications'
import { HIDE_MODAL } from './modal'
import { loadPoolAsync, loadPoolSummaryAsync } from './poolDetails'
import { BACKEND_PROPAGATION_DELAY_MS } from '../constants/delays'

export const UPDATE_BEST_GUESS = 'UPDATE_BEST_GUESS'

export const updateBestGuess = (id, bestGuessObject, partnerId, partnerSubscriptionId) => {
  return dispatch => {

    dispatch({
      type: HIDE_MODAL
    })

    PoolsApi.UpdateBestGuess(id, bestGuessObject, partnerId, partnerSubscriptionId)
      .then(response => {
        if (response.ok) {
          dispatch(addInfoNotification('Best guess was successfully updated'))
          // Delay re-fetching pool data to allow the backend to propagate
          // the best guess change before we read it back
          setTimeout(() => {
            dispatch(loadPoolSummaryAsync({ id: id }))
            dispatch(loadPoolAsync({ id: id }))
          }, BACKEND_PROPAGATION_DELAY_MS)
        }
        else{
          dispatch(addErrorNotification('Error updating best guess', response.statusText))
        }
      })
      .catch(error => {
        dispatch(addErrorNotification('Error updating best guess', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/poolAvailability.js